<template>
  <div class="personal-detail-4">
    <el-form :model="formData" label-position="top" :rules="rules" status-icon ref="ruleForm">
      
      <el-row :gutter="20">
        <p class="experience" v-html="$t('headerMsg.experience')"></p>
        <p class="experienceLabel" v-html="$t('Experience.experienceLabel')"></p>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="blank blank-one">
          <el-row :gutter="24">

            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="blank-h5">
              <el-form-item :label="$t('Experience.Futures_Options')" prop="Futures_Options">
                <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Futures_Options" class="select-width" :placeholder="$t('messages.unSelect')">
                  <el-option v-for="(item,index) in $t('Experience.Futures_Options_select')" :key="index" :label="item" :value="index">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="blank-h5">
              <el-form-item :label="$t('Experience.CFDs_Spread_Bets')" prop="CFDs_Spread_Bets">
                <el-select @visible-change="$elui_Select_Edge"  v-model="formData.CFDs_Spread_Bets" class="select-width" :placeholder="$t('messages.unSelect')">
                  <el-option v-for="(item,index) in $t('Experience.CFDs_Spread_Bets_select')" :key="index" :label="item" :value="index">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>
        </el-col>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="blank">
          <el-row :gutter="24">

            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="blank-h5">
              <el-form-item :label="$t('Experience.Derivative_Trade_over2')" prop="Derivative_Trade_over2">
                <el-radio-group v-model="formData.Derivative_Trade_over2">
                  <div class="radio-h5">
                    <el-radio label="1">{{$t('Experience.Derivative_Trade_over2_select.b')}}</el-radio>
                  </div>
                  <div class="radio-h5">
                    <el-radio label="0">{{$t('Experience.Derivative_Trade_over2_select.a')}}</el-radio>
                  </div>
                </el-radio-group>
              </el-form-item>
            </el-col>
              
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="blank-h5">
              <el-form-item :label="$t('Experience.Derivative_Trade_over40')" prop="Derivative_Trade_over40">
                <el-radio-group v-model="formData.Derivative_Trade_over40">
                  <div class="radio-h5">
                    <el-radio label="1">{{$t('Experience.Derivative_Trade_over40_select.b')}}</el-radio>
                  </div>
                  <div class="radio-h5">
                    <el-radio label="0">{{$t('Experience.Derivative_Trade_over40_select.a')}}</el-radio>
                  </div>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <!-- 暂时英文显示 新加字段  -->
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="blank">
              <el-row :gutter="24">

                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="blank-h5">
                  <el-form-item :label="$t('Experience.Average_Annual_Investment')" prop="Average_Annual_Investment">
                    <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Average_Annual_Investment" class="select-width" :placeholder="$t('messages.unSelect')">
                      <el-option v-for="(item,index) in $t('Experience.Average_Annual_Investment_select')" :key="index" :label="item" :value="index">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="blank-h5">
                  <el-form-item :label="$t('Experience.Average_Leverage_Level')" prop="Average_Leverage_Level">
                    <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Average_Leverage_Level" class="select-width" :placeholder="$t('messages.unSelect')">
                      <el-option v-for="(item,index) in $t('Experience.Average_Leverage_Level_select')" :key="index" :label="item" :value="index">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

              </el-row>
            </el-col>





          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';
  export default {
    name: 'Experience',
    mixins: [
      require("@/assets/mixin/base.js").base('Experience')
    ],
    props: ['Lead', 'middle_dataware'],
    data() {
      return {
         rules: {
          Futures_Options: [{
            required: true , message:'Above is required'
          }],
          CFDs_Spread_Bets: [{
            required: true , message:'Above is required'
          }],
          Derivative_Trade_over2: [{
            required: true , message:'Above is required'
          }],
          Derivative_Trade_over40: [{
            required: true , message:'Above is required'
          }],
          Average_Annual_Investment: [{
           required: true , message:'Above is required'
          }],
          Average_Leverage_Level: [{
           required: true , message:'Above is required'
          }]
        },
        lang:localStorage.getItem('language') === 'en'||false,
      }
    },
    mounted() {
      _g.trackStepPage(4);
    },
    methods:{
      getPageFormData(cb) {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            //更新salesforce步骤
            Util.editSalesforce(this.middle_dataware, 4);
            return cb(true);
          } else {
            // return cb(true);
            return cb(false);
          }
        });
      }
    },
    watch:{
    }
  }

</script>

<style lang="scss">
  .el-form-item--small .el-form-item__label,.el-form-item--small .el-form-item__content {
    line-height: normal;
  }
  .personal-detail-4 {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    .form-tip{
      font-size: 11px;
      color:#939597;
      padding: 10px 0;
    }
    .time-icon-color{
      color: #f2672a;
      margin-right: 10px;
    }
    p{
      margin-left: 16px;
      margin-bottom: 0px;
      font-size: 15px;
    }
    .experience{
       margin-top: 10px; 
    }
    .select-width{
      width: 100%;
    }
    .blank{
      padding-top:25px;
    }
    .el-form-item__label{
      color: black;
    }
    @media (max-width: 768px){
      .blank-h5{
        width: 100% !important;
      }
      .blank{
        padding-top:0px;
      }
      .blank-one{
        padding-top:18px;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/view/steps/experience.vue